export const shortTestimonials = [
  {
    initials: 'RH',
    name: 'Romina H.',
    place: 'Rosario',
    quote: 'Ordené la historia médica en 7 días. Cuando le mostré el archivo al médico, se sorprendió. Me preguntó cómo lo hice.'
  },
  {
    initials: 'LM',
    name: 'Lucía M.',
    place: 'Buenos Aires',
    quote: 'Tenía papeles en la mesa, en sobres, en el celular. Ahora sé dónde está cada cosa. No es un lujo; es paz mental.'
  },
  {
    initials: 'PS',
    name: 'Patricia S.',
    place: 'Córdoba',
    quote: 'El sistema me mostró que tenía información valiosa, pero completamente desordenada. Ahora encuentro lo que necesito en segundos.'
  }
] as const;

export const extendedTestimonials = [
  {
    name: 'Silvia C.',
    place: 'Mendoza',
    quote: '“Mi hijo tiene epilepsia refractaria hace 8 años. Nunca había tenido su historia en un solo lugar. Ahora la tengo clara y actualizable.”'
  },
  {
    name: 'Valentina R.',
    place: 'La Plata',
    quote: '“Tenía miedo de haber perdido estudios importantes. El radar me mostró exactamente qué tenía y qué no. Eso me tranquilizó.”'
  },
  {
    name: 'Mariela T.',
    place: 'San Juan',
    quote: '“La línea de tiempo me permitió ver la evolución de 6 años en una sola página. Finalmente puedo contar la historia completa.”'
  },
  {
    name: 'Daniela P.',
    place: 'Salta',
    quote: '“No sabía que estaba tan desordenada. Después de 7 días tengo un sistema que puedo mantener actualizado. Es increíble.”'
  },
  {
    name: 'Florencia L.',
    place: 'Neuquén',
    quote: '“La carpeta digital ordenada me salvó. Cuando perdí un email importante, la copia estaba ahí esperando.”'
  }
] as const;

export const purchases = [
  ['Lucía M.', 'Buenos Aires'],
  ['Patricia S.', 'Córdoba'],
  ['Romina H.', 'Rosario'],
  ['Silvia C.', 'Mendoza']
] as const;
